exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".instructor_card-wrapper{\n    padding: 10px 20px;\n}\n.instructor_card {\n    border-radius: 10px;\n    border: 2px solid rgba(126, 208, 26, 0.1);\n    width: 100%;\n    max-width: 400px;\n  }\n .details{\n    background-color: rgba(126,208,26,.1);\n }\n\n  .instructor-image {\n    width: 150px;\n    height: 150px;\n    object-fit: cover;\n    border-radius: 50%;\n    object-position: top;\n    object-fit: cover;\n  } ", ""]);

// exports
